import { gql } from "@apollo/client";

export const ACCOUNT_SESSION = gql`
  query AccountSession ($accountId: String!) {
    accountSession(accountId: $accountId) {
      key
    }
  }
`;
